<template>
<div>
	<FormRow>
  		<input
        type="checkbox"
        id="shortNote"
        name="shortNote"
        :checked="shortNote"
        @click="shortNote = $event.target.checked"
      />
  		<FormLabel for="shortNote">{{text}}</FormLabel>
	</FormRow>
	<div  v-if="shortNote" class="shortNote-container">
		<FormRow inline>
			<FormCol field="description" :showLabel="false"/>
		</FormRow>
	</div>
</div>
</template>
<script lang="ts">
import { defineComponent,  ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    text: {
      type:String,
      default: 'I Would like to leave a short note with donation'
    }
  },
  setup() {
    const shortNote = ref(false)
    const { setValue } = usePaymentForm()

    watch(shortNote, () => {
      if (!shortNote.value) {
        setValue('description', null)
      }
    })
    return {
      shortNote,
    }
  },
})
</script>
<style scoped lang="scss">
input[type='checkbox'] {
  margin-right: 7px;
}
</style>